<template>
  <div
    v-if="adItem && adItem.content"
    class="text-center"
    style="background: #E6E6E6;"
  >
    <video
      :src="adItem.content"
      loop
      autoplay
      controls
      muted
      class="ad-design"
    ></video>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    adItem: {
      type: Object,
      default: null
    },
    playAd: {
      type: Boolean,
      default: false
    },
    adIndex: {
      type: Number,
      default: null
    }
  },
  watch: {
    'playAd': function (value) {
      if (value) {
        this.play()
      } else {
        this.pause()
      }
    }
  }
})
export default class Video extends Vue {
  data () {
    return {
      adVideo: null
    }
  }

  mounted () {
    this.adVideo = this.$el.querySelector('video')

    if (!this.adVideo) {
      return false
    }

    this.adVideo.addEventListener('canplay', () => {
      this.adVideo.play()
    }, false)

    this.adVideo.addEventListener('error', () => {
      this.errorLoad()
    }, false)
  }

  play () {
    if (this.adVideo) {
      this.adVideo.play()
    }
  }

  pause () {
    if (this.adVideo) {
      this.adVideo.pause()
    }
  }

  errorLoad () {
    this.$emit('deleteIndex', this.adIndex)
  }
}
</script>
